module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"DetailsItem-arrowdown\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 17 9\" width=\"17\" height=\"9\"><path d=\"M-.002.028l9 8.97 8-8.97-3.69-.03L9 5.01 3.964-.002l-3.967.03z\" class=\"DetailsItem-arrowdownFilled\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader?removeSVGTagAttrs=false!./client/components/Details/arrow_down.svg
// module id = 2063
// module chunks = 0